class productGroup extends HTMLElement {
  constructor() {
    super();

    const productData = {
      pID: this.dataset.currentProduct,
      vID: this.dataset.currentVariant,
      productToUpdateWithOptions: JSON.parse(
        document.querySelector("#product-to-update-with-options").textContent
      ),
      options: JSON.parse(
        document.querySelector("#product-options").textContent
      ),
      variants: JSON.parse(
        document.querySelector("#variants-data").textContent
      ),
      productImages: JSON.parse(
        document.querySelector("#product-images").textContent
      ),
    };
    const uniqueColorsRB = document.querySelectorAll(
      'fieldset input[type="radio"][data-unique-color]'
    );

    /**
     * Local State
     */
    this.carousel = null;
    this.currentProductId = Number(this.dataset.currentProduct);
    this.currentVariantId = Number(this.dataset.currentVariant);
    this.currentVariant = null;

    this.price = this.querySelectorAll(".price-v1 .price__sale dd span");
    this.priceRegular = this.querySelectorAll(".price-v1 .price__regular .price-item--regular");
    this.comparePrice = this.querySelectorAll(".price-v1 .price__sale dd s");
    this.discountValue = Number(
      this.querySelector(".price-v1").getAttribute("data-price-discount")
    );

    this.stickyPrice = document.querySelectorAll(".sticky-atc__wrapper .price-v1 .price__sale dd span");
    this.stickyPriceRegular = document.querySelectorAll(".sticky-atc__wrapper .price-v1 .price__regular .price-item--regular");
    this.stickyComparePrice = document.querySelectorAll(".sticky-atc__wrapper .price-v1 .price__sale dd s");
    this.stickyDiscountValue = Number(
      document.querySelector(".sticky-atc__wrapper .price-v1").getAttribute("data-price-discount")
    );

    this.selectedAdditionalProducts = [];
    this.selectedProducts = [];
    this.selectedOptions = [];

    this.specModalOpen = false;

    this.freeProduct = document.querySelector("[data-free-product-on-add-to-cart]") ? document.querySelector("[data-free-product-on-add-to-cart]") : null;
    this.freeProductId = this.freeProduct ? this.freeProduct.dataset.freeProductOnAddToCart : null;

    /**
     * Assign local state to JSON from DOM.
     */
    this.variants = JSON.parse(
      document.querySelector("#variants-data").textContent
    );
    this.options = productData.options;
    this.productImages = JSON.parse(
      document.querySelector("#product-images").textContent
    ).productImages;

    if (productData.productToUpdateWithOptions) {
      this.productsToUpdateOnOptionChange =
        productData.productToUpdateWithOptions;
    } else {
      this.productsToUpdateOnOptionChange = null;
    }

    /**
     * Move ATC button on mobile
     */
    const atcButtonGroup = this.querySelector("#product-add-to-cart");
    const transportTo = document.querySelector("#sticky-relocate");

    const query = window.matchMedia("(max-width: 1000px)");

    if (query.matches && atcButtonGroup && transportTo) {
      transportTo.append(atcButtonGroup);
      transportTo.style.display = "block";
    }

    /**
     * Move Color Selection on mobile
     * Only on pages using the Day Bed and Kids Bed templates.
     */

    const colorSelection = this.querySelector("#product-form__color-groups");
    const relocateColorSection = document.querySelector(
      "#relocate-color-selection"
    );
    const bedTemplate = document.body.classList.contains("template-day-bed");
    const kidsTemplate = document.body.classList.contains("template-kids-bed");

    if (
      (bedTemplate || kidsTemplate) &&
      query.matches &&
      colorSelection &&
      relocateColorSection
    ) {
      relocateColorSection.append(colorSelection);
      relocateColorSection.style.display = "block";
    }

    /**
     * Get All Dom elements & setup events
     */
    this.setDefaultData();
    this.setUpMainProductEvents();
    this.setUpCustomizeProductsEvents();
    this.setUpSwiper();
    this.setUpDropdowns();
    this.setUpSpecificationsModal();
    uniqueColorsRB.forEach((rb) => {
      rb.addEventListener("change", this.setUniqueColors.bind(this));
    });
    
    // Add resize event listener to handle viewport changes for custom layout
    this.handleResize = this.debounce(() => {
      this.updateSwiper();
    }, 250);
    window.addEventListener('resize', this.handleResize);
    
    this.updateSwiper();
  }

  /**
   * Initialize Funcitons
   */
  setDefaultData() {
    const localOptions = [];
    const currentVariant = this.variants.find((v) => {
      return v.id === this.currentVariantId;
    });

    currentVariant.options.forEach((option, idx) => {
      const selection = {
        name: this.options[idx].name,
        value: option,
      };
      localOptions.push(selection);
      this.selectedOptions.push(selection);
      this.updateCustomizeProductToMatch(this.options[idx].name, option);
    });

    this.currentVariant = currentVariant;
  }

  setUpMainProductEvents() {
    $('.product-form__variant-list input[type="radio"]').click(
      this.selectOption.bind(this)
    );
    $(".final-add-to-cart").click(this.addToCart.bind(this));
  }


  setUpCustomizeProductsEvents() {
    $(".customize-product").click(
      this.updateSelectedAdditionalProducts.bind(this)
    );
    $(".customize-product .customize-product__swatch").click(
      this.updateSelectedAdditionalProducts.bind(this)
    );
    $(".customize-product__checkbox").click(
      this.updateSelectedAdditionalProducts.bind(this)
    );
    $('.addon-accordians-block input[type="checkbox"]').on('change', function() {
      const multipleAddonBlock = $('.addon-accordians-block input[type="checkbox"]');
      multipleAddonBlock.each(function() {
        if (!$(this).is(':focus')) {
          $(this).trigger('click');
        }
      });

      this.updateSelectedAdditionalProducts();
    }.bind(this));
    $('.bundle-custom-input').click(function (event) {
      const bundleProduct = event.currentTarget.closest('.bundle-product');
      if (bundleProduct) {
        bundleProduct.classList.toggle('active');
        const selectedInputs = bundleProduct.querySelectorAll('.product-info__hover');
        selectedInputs.forEach((input) => {
          this.updateSelectedAdditionalProducts(input);
        });
      }
    }.bind(this));

  }

  setUpSwiper() {
    /**
     * Initialize Slider
     */
    let pdpSlider;
    const findSimple = document.querySelector(".product__media-wrapper .product-main-simple");
    if(findSimple){
       pdpSlider = new Swiper(".product-media-list-simple", {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }else{
       pdpSlider = new Swiper('.product__media-wrapper .product__media-list-custom', {
        slidesPerView: 'auto',
        loop: false,
        freeMode: false,
        spaceBetween: 8,
        pagination: {
          el: '.product__media-wrapper .swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.product__media-wrapper .swiper-button-next',
          prevEl: '.product__media-wrapper .swiper-button-prev',
        },
        breakpoints: {
          1001: {
            direction: "vertical",
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.product__media-wrapper .swiper-button-next',
              prevEl: '.product__media-wrapper .swiper-button-prev',
              disabledClass: 'swiper-button-disabled'
            }
          }
        }
      });
    }
    // 

    window.pdpSlider = pdpSlider;

    /**
     * On thumbnail click
     */
    $(".product").on("click", ".product__slider-thumbnail-item", function () {
      var idx = $(this).data("slideid");

      $(".product__slider-thumbnail-item").removeClass("active");
      $(this).addClass("active");

      pdpSlider.slideToLoop(idx);
    });

    /**
     * On slide change
     */
    pdpSlider.on("slideChange", function (slider) {
      var idx = slider.realIndex;

      $(".product__slider-thumbnail-item").removeClass("active");
      $(`.product__slider-thumbnail-item[data-slideid="${idx}"]`).addClass(
        "active"
      );
    });

    this.carousel = pdpSlider;
  }

  setUpDropdowns() {
    /**
     * Dropdowns
     */
    $(".product__dropdown-header").click(function () {
      $(this).toggleClass("active");
      $(this).siblings(".product__dropdown-content").slideToggle(400);
    });

    $(".product__dropdown-header.active").each(function () {
      $(this).siblings(".product__dropdown-content").slideToggle(400);
    });
  }

  setUpSpecificationsModal() {
    $("[data-modal-specifications-button]").click(this.toggleModal.bind(this));
    $("[data-modal-specifications-close-btn]").click(
      this.toggleModal.bind(this)
    );
  }

  /**
   * Cleanup when component is removed
   */
  disconnectedCallback() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  /**
   * Utility function to debounce resize events
   */
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   *
   * Methods for updating local data
   */
  selectOption(evt) {
    const uniqueColorsRB = document.querySelectorAll(
      'fieldset input[type="radio"][data-unique-color][checked]'
    );
    if (!evt.currentTarget.dataset.uniqueColor && uniqueColorsRB.length > 0) {
      const actualFieldSet = evt.currentTarget.closest("fieldset");
      const parentVariants = actualFieldSet.parentNode;
      const allFieldSets = parentVariants.querySelectorAll("fieldset");
      const siblingFieldSet = Array.from(allFieldSets).filter(function (
        fieldset
      ) {
        return fieldset !== actualFieldSet;
      })[0];
      const selectedRadioButton = siblingFieldSet.querySelector(
        'input[type="radio"]:checked'
      );
      const value = selectedRadioButton ? selectedRadioButton.value : null;
      const validRadioButtons = siblingFieldSet.querySelectorAll(
        'input[type="radio"]:not([data-unique-color]):not([value="' +
        value +
        '"])'
      );
      const randomRadioIndex = Math.floor(
        Math.random() * validRadioButtons.length
      );
      const randomRadio = validRadioButtons[randomRadioIndex];
      const uniqueMsg = this.querySelector(".pdp-bundle-unique-msg");
      uniqueMsg.classList.add("hide");
      uniqueColorsRB.forEach((rb) => {
        rb.checked = false;
        rb.removeAttribute("checked");
      });
      randomRadio.click();
    }

    // Proceed only if the target's name matches the condition
    if (evt.currentTarget.name) {
      const nameLowerCase = evt.currentTarget.name.toLowerCase();
      const selectedRadioValue = evt.currentTarget.value;
      const completeSetContainer = document.querySelector('.complete-the-set-container');

      document.querySelectorAll('.product-form__customization').forEach(wrapper => {
        const customizeProductElement = wrapper.querySelector('.customize-product.match-main-product');
        const matchBasedOn = customizeProductElement ? customizeProductElement.getAttribute('data-match-based-on') : null;
        if (nameLowerCase === matchBasedOn) {
          let addOnHide = false;
          wrapper.querySelectorAll('.product-form__variant-list .input-label').forEach(input => {
            let inputVal = input.querySelector('input').value;
            if (selectedRadioValue == inputVal) {
              addOnHide = true;
              input.querySelector('input').closest('.input-label').classList.remove('hidden');
              input.querySelector('input').closest('.input-label').querySelector('label').click();

              const variantActive = input.closest('.product-form__variant-list').nextElementSibling.querySelector('.body-4.caps');
              if (variantActive) {
                variantActive.textContent = selectedRadioValue;
              }
              
              // Update the customize product price when variant changes
              updateCustomizeProductPrice(input.querySelector('label'));
            } else {
              input.querySelector('input').closest('.input-label').classList.add('hidden');
            }
          });
          if (completeSetContainer) {
            if (addOnHide) {
              completeSetContainer?.classList.remove('hidden');
            } else {
              completeSetContainer?.classList.add('hidden');
            }
          }
        } else {
          wrapper.querySelectorAll('.product-form__variant-list .input-label').forEach(inputLabel => {
            if (matchBasedOn == nameLowerCase) {
              inputLabel.classList.remove('hidden');
            }
          });
        }


        wrapper.querySelectorAll('.product-form__variant-list .input-label').forEach(inputLabel => {
          if (matchBasedOn == nameLowerCase) {
            let inputHiddenLen = inputLabel.closest('.product-form__variant-list').querySelectorAll('.input-label.hidden').length;
            let inputLen = inputLabel.closest('.product-form__variant-list').querySelectorAll('.input-label').length;
            if (inputHiddenLen == inputLen) {
              inputLabel.closest('.customize-product').classList.add('not-active');
            } else {
              inputLabel.closest('.customize-product').classList.remove('not-active');
            }
          }
        });

      });


    }



    const optionName = evt.currentTarget.dataset.optionName;
    const value = evt.currentTarget.dataset.name;
    const variantImageSelect = evt.currentTarget.dataset.variantImage;
    const variantOptionImage = evt.currentTarget.dataset.optionImage;
    const variantOptionType = evt.currentTarget.dataset.variantType;
    const currentValue = this.selectedOptions.find(
      (option) => option.name === optionName
    );

    const productProps = document.querySelectorAll('.product__prop-item');
    if (value.toLowerCase().includes('boucle')) {
      if (productProps.length > 0) {
        productProps.forEach(prop => {
        if(prop?.dataset?.propValue?.toLowerCase().trim() == 'stain-resistant fabric'){
          prop.classList.add('hidden');
        } else {
          prop.classList.remove('hidden');
        }
      });
      }
    } else {
      if (productProps.length > 0) {
        productProps.forEach(prop => {
          prop.classList.remove('hidden');
        });
      }
    }




    if(variantImageSelect){
      const multipleStickyImage = document.querySelectorAll(".sticky-product-image");
      multipleStickyImage.forEach(stickyImage => {
        const image = stickyImage.querySelector("img");
        image.src = variantImageSelect;
        image.srcset = variantImageSelect;
      })
    }

    if(variantOptionImage){
      const stickyVariantImage = document.querySelector(".sticky-product-variants .active-varient-img");
      const getImage = stickyVariantImage.querySelector("img");
      getImage.src = variantOptionImage;
      getImage.srcset = variantOptionImage;
    }

    const stickyVariantImage = document.querySelector(".sticky-product-variants .variant-type");
    if(variantOptionType){
      stickyVariantImage.textContent = '(' + variantOptionType + ')';
    } else {
      stickyVariantImage.textContent = '';
    }

    if (currentValue && value) {
      currentValue.value = value;
    }
    this.getNewVariantFromOptions();

    const textContent = document.querySelector('.text-content[data-variants-to-hide]');

    if (textContent) {
      const variantsToHide = textContent.dataset.variantsToHide.split(',').map(variant => variant.trim());

      if (currentValue && currentValue.value) {
          if (variantsToHide.includes(currentValue.value)) {
              textContent.classList.add('hidden');
          } else {
              textContent.classList.remove('hidden');
          }
      }
    }

    if (
      $(
        `.product__shipping[data-id=${this.currentVariant.id}]`
      ).text() !== ""
    ) {
      $(".product__shipping").addClass("hide");
      $(
        `.product__shipping[data-id=${this.currentVariant.id}]`
      ).removeClass("hide");
    } else {
      $(".product__shipping").addClass("hide");
    }

    this.updateCustomizeProductToMatch(optionName, value);
    evt.currentTarget.closest('.product-main-variant-block').querySelector(
      "p.body-4.caps"
    ).textContent = value;
    const stickyVariant = document.querySelector(".sticky-selected-variant .product-main-variant-block");
    stickyVariant.querySelector("p.body-4.caps").textContent = value;
    document.querySelector(".sticky-atc__wrapper .sticky-selected-variant-title").textContent = value;

    const babylistData = document.querySelector(`.babylist-data-${this.dataset.currentProduct}`)?.textContent;
    const parsedData = babylistData ? JSON.parse(babylistData) : null;
    const hasBabylistVariant = parsedData?.babylist.find(b => 
      b.variant_id === this.currentVariant.id && b.babylist === true
    );
    const babylistContainer = document.querySelector('#babylist');
    const addToCartBtns = document.querySelectorAll('.product-add-to-cart');
    const babyListBtns = document.querySelectorAll('.babylist-button');

    if (babylistContainer && babyListBtns.length > 0) {
      if (hasBabylistVariant) {
        babylistContainer.classList.remove("hidden");
        addToCartBtns.forEach(btn => btn.querySelector('.product-form').classList.add("hidden"));
        babyListBtns.forEach(btn => btn.classList.remove("hidden"));
      } else {
        babylistContainer.classList.add("hidden");
        addToCartBtns.forEach(btn => btn.querySelector('.product-form').classList.remove("hidden"));
        babyListBtns.forEach(btn => btn.classList.add("hidden"));
      }
    }

    updateSwatches();
    
    const variantName = evt.currentTarget.dataset.name;
    const getaddonVariant = $('.addon-accordians-block .addon-variant-options option');
    const getAddonProductImage = $('.addon-accordians-block img.addon-product-image');
    const getStickyAddonProductImage = $('.sticky-headrest-addon img.addon-product-image');
    const getAddonvariantId = $('.addon-accordians-block input');
    getaddonVariant.each(function(){
      const optionValue = $(this).data('value');
      if(optionValue == variantName){
        const variantImage = $(this).data('variant-image');
        const variantId = $(this).data('variant-id');
        if (variantImage && getAddonProductImage.length) {
          getAddonProductImage.each(function() {
            $(this).attr('src', variantImage);
            $(this).attr('srcset', variantImage);
          });
        }
        if (variantImage && getStickyAddonProductImage.length) {
          getStickyAddonProductImage.each(function() {
            $(this).attr('src', variantImage);
            $(this).attr('srcset', variantImage);
          });
        }
        if (variantId && getAddonvariantId.length) {
          getAddonvariantId.each(function(){
            $(this).attr("data-variant-id", variantId);
          });
        }
      }
    });

    
  }

  /**
   * Set Unique Colors Events
   */
  setUniqueColors(evt) {
    const value = evt.currentTarget.dataset.name;
    const radioButtons = document.querySelectorAll(
      `fieldset input[type="radio"][data-name="${value}"]`
    );
    const $radioBtns = $(radioButtons);
    const uniqueMsg = this.querySelector(".pdp-bundle-unique-msg");
    uniqueMsg.classList.remove("hide");
    radioButtons.forEach((radioButton) => {
      if (radioButton.dataset.name === value) {
        radioButton.checked = true;
        radioButton.setAttribute("checked", true);
        const changeEvent = new Event("click", {
          bubbles: true,
          cancelable: false,
        });
        radioButton.dispatchEvent(changeEvent);
      }
    });
    $radioBtns.each(function () {
      $(this).click();
    });
  }

  getNewVariantFromOptions() {
    const flatSelectedOptions = this.selectedOptions.flatMap((option) => {
      return option.value;
    });

    const newVariant = this.variants.find((variant) => {
      return (
        JSON.stringify(variant.options) === JSON.stringify(flatSelectedOptions)
      );
    });

    if (!newVariant) return;
    this.updateVariantData(newVariant);
  }

  updateVariantData(variant) {
    this.currentVariant = variant;
    this.updateURL();
    this.updateSwiper();
    this.updateAtcBtn();
  }

  updateSelectedAdditionalProducts(evt) {
    const customizeProducts = $(".customize-product.customize-product--active");
    const temp = [];

    customizeProducts.each((idx, product) => {
      const isSelected = Number($(product).attr("data-customization-selected"));
      const id = Number($(product).attr("data-selected-variant"));
      const price =
        Number(window.igData?.price?.getPriceByVariantId(id)) ||
        Number($(product).attr("data-price"));
      const prodId = Number($(product).attr("data-product-id"));
      const optionValue = $(product).attr("data-option-value");
      const patternOptionKey = $(product).attr("data-pattern-option-key");
      const ignoreImageFiltering =
        $(product).attr("data-ignore-image-filtering") === "true";
      const quantity = $(product).attr("data-quantity");
      const imagePriority = $(product).attr("data-image-priority");

      if (isSelected === 1) {
        temp.push({
          id,
          quantity,
          price,
          prodId,
          optionValue,
          patternOptionKey,
          ignoreImageFiltering,
          imagePriority,
        });
      }
    });

    const addonProducts = $('.addon-accordians-block input[type="checkbox"]:checked')[0];
    if(addonProducts){
      const id = Number($(addonProducts).attr("data-variant-id"));
      const price =
        Number(window.igData?.price?.getPriceByVariantId(id)) ||
        Number($(addonProducts).attr("data-price"));
      const prodId = Number($(addonProducts).attr("data-product-id"));
      const quantity = Number($(addonProducts).attr("data-quantity")) || 1;
  
      temp.push({
        id,
        quantity,
        price,
        prodId,
      });
    }

    const bundleProductList = $('.bundle-product.active');
    bundleProductList.each((idx, bundleProduct) => {
      const $bundleProduct = $(bundleProduct);
      const $checkedInput = $bundleProduct.find('.product-form__variant-list input[type="radio"]:checked');
      if ($checkedInput.length > 0) {
        const id = Number($checkedInput.attr("data-variant-id"));
        const price =
          Number(window.igData?.price?.getPriceByVariantId(id)) ||
          Number($checkedInput.attr("data-price"));
        const prodId = Number($checkedInput.attr("data-product-id"));
        const quantity = Number($checkedInput.attr("data-quantity")) || 1;
    
        temp.push({
          id,
          quantity,
          price,
          prodId,
        });
      }
    });
    
    this.selectedAdditionalProducts = temp;
    this.updateAtcBtn();
    this.updateSwiper();
  }

  getCurrentPriceTop() {
    let price =
      Number(window.igData?.price?.getPriceByVariantId(this.currentVariant.id)) *
      100 || this.currentVariant.price;


    const badges = document.querySelectorAll(".price__badge-sale");

    const discountData = document.querySelector(`.price__discount-data-${this.dataset.currentProduct}`)?.textContent;
    let discountValue = this.discountValue;
  
    if (discountData && this.currentVariant.compare_at_price == this.currentVariant.price) {
      
      try {
        const discounts = JSON.parse(discountData).discounts;
        const discountForVariant = discounts.find(
          (d) => d.variant_id === this.currentVariant.id
        );
  
        if (discountForVariant) {
          discountValue = discountForVariant.discount;
        }
      } catch (error) {
        const fixedData = discountData.replace(/,\s*([\]}])/g, "$1");
  
        try {
          const discounts = JSON.parse(fixedData).discounts;
          const discountForVariant = discounts.find(
            (d) => d.variant_id === this.currentVariant.id
          );
  
          if (discountForVariant) {
            discountValue = discountForVariant.discount;
          }
        } catch (error) {
          console.error("Bad JSON:", error);
        }
      }
    } else if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      discountValue = this.currentVariant.compare_at_price - this.currentVariant.price;
    }

    // Only apply metafield discount if there's no compare_at_price discount already
    if (discountValue && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
      price = price - discountValue;
    }

    if (badges) {
      badges.forEach((badge) => {
        if (badge.dataset.clearancePercentage) {
          const percentageDiscount = Math.round((discountValue / this.currentVariant.compare_at_price) * 100);
          badge.innerHTML = `${percentageDiscount}% OFF`;
        } else {
          badge.innerHTML = `Save $${discountValue / 100}`;
        }
        badge.classList.remove("hidden");

        if (discountValue === 0) {
          badge.classList.add("hidden");
        }
      });
    }

    return new Intl.NumberFormat().format(price / 100);
  }

  getSelectedAdditionalProducts() {
    return this.selectedAdditionalProducts.length;
  }

  getCurrentPrice() {
    let price =
      Number(window.igData?.price?.getPriceByVariantId(this.currentVariant.id)) *
      100 || this.currentVariant.price;

    const badges = this.querySelectorAll(".price__badge-sale");
    if (this.selectedAdditionalProducts.length > 0) {
      this.selectedAdditionalProducts.forEach((prod) => {
        price = price + prod.price * prod.quantity;
      });
    }

    const discountData = document.querySelector(`.price__discount-data-${this.dataset.currentProduct}`)?.textContent;
    let discountValue = this.discountValue;
  
    if (discountData && this.currentVariant.compare_at_price == this.currentVariant.price) {
      
      try {
        const discounts = JSON.parse(discountData).discounts;
        const discountForVariant = discounts.find(
          (d) => d.variant_id === this.currentVariant.id
        );
  
        if (discountForVariant) {
          discountValue = discountForVariant.discount;
        }
      } catch (error) {
        const fixedData = discountData.replace(/,\s*([\]}])/g, "$1");
  
        try {
          const discounts = JSON.parse(fixedData).discounts;
          const discountForVariant = discounts.find(
            (d) => d.variant_id === this.currentVariant.id
          );
  
          if (discountForVariant) {
            discountValue = discountForVariant.discount;
          }
        } catch (error) {
          console.error("No se pudo corregir el JSON:", error);
        }
      }
    }
     else if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      discountValue = this.currentVariant.compare_at_price - this.currentVariant.price;
    }

    // Only apply metafield discount if there's no compare_at_price discount already
    if (discountValue && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
      price = price - discountValue;
    }

    if (badges) {
      badges.forEach((badge) => {
        if (badge.dataset.clearancePercentage) {
          const percentageDiscount = Math.round((discountValue / this.currentVariant.compare_at_price) * 100);
          badge.innerHTML = `${percentageDiscount}% OFF`;
        } else {
          badge.innerHTML = `Save $${discountValue / 100}`;
        }
      });
    }

    return new Intl.NumberFormat().format(price / 100);
  }

  getTotalCompareAtPrice() {
    let totalComparePrice = this.currentVariant.compare_at_price || this.currentVariant.price;

    // Add compare_at_price of additional products, or their regular price if no compare_at_price
    if (this.selectedAdditionalProducts.length > 0) {
      this.selectedAdditionalProducts.forEach((prod) => {
        // For additional products, if they don't have compare_at_price, use their regular price
        // We assume additional products don't have complex discount logic like the main product
        totalComparePrice = totalComparePrice + (prod.price * prod.quantity);
      });
    }

    return totalComparePrice;
  }

  /**
   * Methods to update the Dom
   */
  updateSwiper() {
    let newImages = [];
    let localLastImages = [];
    if (this.lastImages) {
      localLastImages = this.lastImages;
    }
    const $thumbnails = $(".product__media-thumbnails");
    /**
     * Loop through images and grab all related images
     */
    const newSlides = [];
    const newThumbs = [];

    // find current product images
    /**
     * Find current product images
     */
    const currentProductImages = this.productImages;
    let normalizeVariant;
    if (this.currentVariant) {
      normalizeVariant = this.currentVariant.title
        .trim()
        .replace("/", "")
        .replace(/\s/g, "")
        .toLowerCase();
    }

    let matchAltTo = normalizeVariant;

    let currentProductIds = [this.currentProductId];

    /**
     * TODO: Need to extend ths into adding the variant options of additional products.
     * Must also match 1 of the product ids
     *
     * Pattern
     * - Top color / Base color / Rail color / Rail quantity
     */
    if (this.selectedAdditionalProducts.length > 0) {
      let tempCurrentProducts = [];
      let lastPriority = 0;
      let filledInRails = false;

      this.selectedAdditionalProducts.forEach((product) => {
        if (product.ignoreImageFiltering) return;

        let priority = Number(product.imagePriority);

        if (priority > lastPriority) {
          tempCurrentProducts = [product.prodId];
          lastPriority = priority;
        } else if (priority === lastPriority) {
          tempCurrentProducts.push(product.prodId);
        }

        if (product.patternOptionKey && product.patternOptionKey.toLowerCase() === "rails color") {
          if (filledInRails) return;
          if (product.optionValue) {
            if (product.quantity == 1) {
              matchAltTo = `${matchAltTo}${product.optionValue.toLowerCase()}`;
            } else {
              matchAltTo = `${matchAltTo}${product.optionValue.toLowerCase()}2`;
            }
            filledInRails = true;
          }
        }
      });

      if (tempCurrentProducts.length === 0) {
        currentProductIds = [this.currentProductId];
      } else {
        currentProductIds = tempCurrentProducts;
      }
    }

    // Check if we're using the custom layout pattern and viewport is desktop
    const hasCustomLayoutElement = document.querySelector('.product__media-list-custom') !== null;
    const isDesktop = window.innerWidth > 999;
    const isCustomLayout = hasCustomLayoutElement && isDesktop;
    
    // Filter images first
    const filteredImages = [];
    currentProductImages.forEach((image) => {
      const normalizedAlt = image.alt
        .trim()
        .replaceAll("/", "")
        .replaceAll(/\s/g, "")
        .toLowerCase();

      if (
        normalizedAlt === matchAltTo &&
        currentProductIds.includes(image.productId)
      ) {
        filteredImages.push(image);
      }
    });

    if (isCustomLayout) {
      // Custom layout pattern: slides 1,2 single images, slide 3 double images, repeat
      let slideCount = 1;
      let imageIndex = 0;
      
      while (imageIndex < filteredImages.length) {
        const slidePattern = (slideCount - 1) % 3; // 0, 1, 2 pattern
        
        if (slidePattern === 0 || slidePattern === 1) {
          // Single image slides (slides 1, 2, 4, 5, 7, 8, etc.)
          const image = filteredImages[imageIndex];
          if (!image) break;
          
          let slide = '';
          if (image.type === 'video') {
            slide = `
            <li class="product__media-item swiper-slide single-image media-is-video" data-media-id="{{ section.id }}-${image.id}" data-slideid="${slideCount - 1}">
              <div class="product__media media">
                <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">
                  <video controls${image.autoplay ? ' autoplay' : ''} loop muted playsinline>
                    <source src="${image.src}" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                </div>        
              </div>
            </li>`;
          } else {
            slide = `
            <li class="product__media-item swiper-slide single-image" data-media-id="{{ section.id }}-${image.id}" data-slideid="${slideCount - 1}">
              <div class="product__media media">
                <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">
                  <img src="${image.src}" class="lazyload lazyload--blur" data-src="${image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="${image.id}">
                </div>        
              </div>
            </li>`;
          }
          
          newSlides.push(slide);
          imageIndex++;
          
        } else if (slidePattern === 2) {
          // Double image slide (slides 3, 6, 9, etc.)
          const image1 = filteredImages[imageIndex];
          const image2 = filteredImages[imageIndex + 1];
          
          if (!image1) break;
          
          let slide = `
          <li class="product__media-item swiper-slide double-image" data-media-id="{{ section.id }}-${image1.id}" data-slideid="${slideCount - 1}">
            <div class="double-image-container">
              <div class="image-half">
                <div class="product__media media">
                  <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">`;
          
          if (image1.type === 'video') {
            slide += `
                    <video controls${image1.autoplay ? ' autoplay' : ''} loop muted playsinline>
                      <source src="${image1.src}" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>`;
          } else {
            slide += `
                    <img src="${image1.src}" class="lazyload lazyload--blur" data-src="${image1.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image1.alt}" data-media-id="${image1.id}">`;
          }
          
          slide += `
                  </div>
                </div>
              </div>`;
          
          if (image2) {
            slide += `
              <div class="image-half">
                <div class="product__media media">
                  <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">`;
            
            if (image2.type === 'video') {
              slide += `
                    <video controls${image2.autoplay ? ' autoplay' : ''} loop muted playsinline>
                      <source src="${image2.src}" type="video/mp4">
                      Your browser does not support the video tag.
                    </video>`;
            } else {
              slide += `
                    <img src="${image2.src}" class="lazyload lazyload--blur" data-src="${image2.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image2.alt}" data-media-id="${image2.id}">`;
            }
            
            slide += `
                  </div>
                </div>
              </div>`;
            imageIndex += 2; // Skip next image as it's included in this slide
          } else {
            imageIndex += 1; // Only one image left
          }
          
          slide += `
            </div>
          </li>`;
          
          newSlides.push(slide);
        }
        
        slideCount++;
      }
      
      // Generate thumbnails for custom layout (one thumb per image)
      filteredImages.forEach((image, index) => {
        const addClass = index === 0 ? "active" : "";
        let thumb = '';
        
        if (image.type === 'video') {
          thumb = `
          <div class="product__slider-thumbnail-item ${addClass} media-is-video" data-media-id="{{ section.id }}-${image.id}" data-slideid="${index}">
            <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 1.0">
              <img src="${image.preview_image || image.src}" class="lazyload lazyload--blur" data-src="${image.preview_image || image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="{{ section.id }}-${image.id}" sizes="430px">
              <span class="product__media-icon motion-reduce">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.13245 0.0898438C0.798856 0.0898438 0.517107 0.371593 0.517107 0.705188V12.9192C0.517107 13.2528 0.798856 13.5345 1.13245 13.5345C1.26741 13.5345 1.39569 13.488 1.49537 13.4036L9.74555 7.29654C9.89938 7.16942 9.99999 6.96898 9.99999 6.75686C9.99999 6.54474 9.89938 6.3443 9.74555 6.21718L1.49537 0.110157C1.39569 0.0257175 1.26741 -0.020752 1.13245 -0.020752C1.13245 0.0898438 1.13245 0.0898438 1.13245 0.0898438ZM1.74778 1.47478L8.75167 6.75686L1.74778 12.0389V1.47478Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>`;
        } else {
          thumb = `
          <div class="product__slider-thumbnail-item ${addClass}" data-media-id="{{ section.id }}-${image.id}" data-slideid="${index}">
            <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 1.0">
              <img src="${image.src}" class="lazyload lazyload--blur" data-src="${image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="{{ section.id }}-${image.id}" sizes="430px">
            </div>
          </div>`;
        }
        
        newThumbs.push(thumb);
        newImages.push(image.id);
      });
      
    } else {
      // Original functionality - one slide per image
      let count = 1;

      filteredImages.forEach((image) => {
        let slide = '';
        
        // Check if the media is a video or an image
        if (image.type === 'video') {
          slide = `
          <li class="product__media-item swiper-slide media-is-video" data-media-id="{{ section.id }}-${image.id}" data-slideid="${count - 1}">
            <div class="product__media media">
              <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">
                <video controls${image.autoplay ? ' autoplay' : ''} loop muted playsinline>
                  <source src="${image.src}" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </div>        
            </div>
          </li>`;
        } else {
          // Default image handling
          slide = `
          <li class="product__media-item swiper-slide" data-media-id="{{ section.id }}-${image.id}" data-slideid="${count - 1}">
            <div class="product__media media">
              <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 100%">
                <img src="${image.src}" class="lazyload lazyload--blur" data-src="${image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="${image.id}">
              </div>        
            </div>
          </li>`;
        }

        newSlides.push(slide);

        const addClass = count == 1 ? "active" : "";
        let thumb = '';
        
        // Create thumbnail for both video and image
        if (image.type === 'video') {
          // For video thumbnails, use a preview image if available, otherwise use a play icon overlay
          thumb = `
          <div class="product__slider-thumbnail-item ${addClass} media-is-video" data-media-id="{{ section.id }}-${image.id}" data-slideid="${count - 1}">
            <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 1.0">
              <img src="${image.preview_image || image.src}" class="lazyload lazyload--blur" data-src="${image.preview_image || image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="{{ section.id }}-${image.id}" sizes="430px">
              <span class="product__media-icon motion-reduce">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" fill="none" viewBox="0 0 10 14">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.13245 0.0898438C0.798856 0.0898438 0.517107 0.371593 0.517107 0.705188V12.9192C0.517107 13.2528 0.798856 13.5345 1.13245 13.5345C1.26741 13.5345 1.39569 13.488 1.49537 13.4036L9.74555 7.29654C9.89938 7.16942 9.99999 6.96898 9.99999 6.75686C9.99999 6.54474 9.89938 6.3443 9.74555 6.21718L1.49537 0.110157C1.39569 0.0257175 1.26741 -0.020752 1.13245 -0.020752C1.13245 0.0898438 1.13245 0.0898438 1.13245 0.0898438ZM1.74778 1.47478L8.75167 6.75686L1.74778 12.0389V1.47478Z" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
        `;
        } else {
          thumb = `
          <div class="product__slider-thumbnail-item ${addClass}" data-media-id="{{ section.id }}-${image.id}" data-slideid="${count - 1}">
            <div class="aspect-ratio img-fill" style="max-width: 100%; width: 100%; --aspect-ratio: 1.0">
              <img src="${image.src}" class="lazyload lazyload--blur" data-src="${image.src}" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="${image.alt}" data-media-id="{{ section.id }}-${image.id}" sizes="430px">
            </div>
          </div>
        `;
        }

        newThumbs.push(thumb);
        newImages.push(image.id);
        count++;
      });
    }

    /**
     * Compare new images with to see if we should update gallery
     */
    if (JSON.stringify(newImages) === JSON.stringify(localLastImages)) {
      return;
    }

    /**
     * Reset for the next update
     */
    this.lastImages = newImages;

    /**
     * Update carousel
     */
    this.carousel.removeAllSlides();
    this.carousel.appendSlide(newSlides);
    setTimeout(() => {
      this.carousel.slideToLoop(0);
    }, 100);

    $thumbnails.empty();
    $thumbnails.append(newThumbs);

    let $stackImages = $(".stack-image-wrapper.stack-image-main");
    $stackImages.empty();
    $stackImages.append(newSlides);
  }

  updateAtcBtn() {
    const button = $(".final-add-to-cart");
    // const stickyPriceVariant = $(".sticky-atc__wrapper .price-v1");
    // new

    /**
     * Check variant
     */
    const soldOutText = button.data("soldOutText");

    /**
     * Is variant available?
     */
    if (this.currentVariant) {
      const discountData = document.querySelector(`.price__discount-data-${this.dataset.currentProduct}`)?.textContent;
      let discountValue = this.discountValue;
    
      if (discountData && this.currentVariant.compare_at_price == this.currentVariant.price) {
        try {
          const discounts = JSON.parse(discountData).discounts;
          const discountForVariant = discounts.find(
            (d) => d.variant_id === this.currentVariant.id
          );
    
          if (discountForVariant) {
            discountValue = discountForVariant.discount;
          }
        } catch (error) {
    
          const fixedData = discountData.replace(/,\s*([\]}])/g, "$1");
    
          try {
            const discounts = JSON.parse(fixedData).discounts;
            const discountForVariant = discounts.find(
              (d) => d.variant_id === this.currentVariant.id
            );
    
            if (discountForVariant) {
              discountValue = discountForVariant.discount;
            }
          } catch (error) {
            console.error("Bad JSON:", error);
          }
        }
      }
      else if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        discountValue = this.currentVariant.compare_at_price - this.currentVariant.price;
      }
    

      if (this.currentVariant.available) {
        // Only show price offset if metafield discount applies (no compare_at_price discount)
        const priceOffset = (discountValue || !(this.currentVariant.compare_at_price > this.currentVariant.price));
        const variantId = this.getSelectedAdditionalProducts() > 0 ? '' : `data-variant-id="${this.currentVariant.id}"`;
        // Calculate if we should show crossed-out price
        const hasCompareDiscount = this.currentVariant.compare_at_price > this.currentVariant.price;
        const hasPriceOffset = discountValue && !(this.currentVariant.compare_at_price > this.currentVariant.price);
        const shouldShowCrossedPrice = hasCompareDiscount || hasPriceOffset;
        
        let crossedOutPrice = '';
        if (hasCompareDiscount) {
          // Use total compare at price including additional products
          const totalComparePrice = this.getTotalCompareAtPrice();
          crossedOutPrice = totalComparePrice ? `$${new Intl.NumberFormat().format(totalComparePrice / 100)}` : '';
        } else if (hasPriceOffset) {
          // Calculate original price before discount including additional products
          let originalTotalPrice = this.currentVariant.price;
          if (this.selectedAdditionalProducts.length > 0) {
            this.selectedAdditionalProducts.forEach((prod) => {
              originalTotalPrice = originalTotalPrice + (prod.price * prod.quantity);
            });
          }
          crossedOutPrice = `$${new Intl.NumberFormat().format(originalTotalPrice / 100)}`;
        }

        const template = `
          <span>Add to cart</span>
          <p class="point"></p>
          <div class="price-container">
            <p class="price ">$</p>
                     <p id="buttonMoneyPrice" class="price ${this.getSelectedAdditionalProducts() > 0 ? '' : 'igPrice'}" ${variantId} ${priceOffset}>${this.getCurrentPrice()}</p>${shouldShowCrossedPrice ? `&nbsp;<s id="buttonMoneyComparePrice" class="igComparePrice" data-variant-id="${this.currentVariant.id}">${crossedOutPrice}</s>` : ''}
          </div>
        `;
        button.html(template);
        button.attr("disabled", false);
      } else {
        const template = `
          <span>${soldOutText}</span>
          <p class="point"></p>
          <div class="price-container">
            <p class="price"></p>
            <p id="buttonMoneyPrice" class="price" style="opacity: 0; width: 0">XXX</p>
          </div>
        `;
        button.html(template);
        button.attr("disabled", true);
      }

      this.price.forEach((price) => {
        price.innerHTML = `$${this.getCurrentPriceTop()}`;
        // Only set price offset if metafield discount applies (no compare_at_price discount)
/*         if (discountValue != 0 && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
          price.setAttribute("data-price-offset", `-${discountValue / 100}`);
        } */
        price.setAttribute("data-variant-id", this.currentVariant.id);
      });

      this.stickyPrice.forEach((price) => {
        price.innerHTML = `$${this.getCurrentPrice()}`;
        // Only set price offset if metafield discount applies (no compare_at_price discount)
/*         if (discountValue != 0 && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
          price.setAttribute("data-price-offset", `-${discountValue / 100}`);
        } */
        price.setAttribute("data-variant-id", this.currentVariant.id);
      });

      this.priceRegular.forEach((price) => {
        price.innerHTML = `$${this.getCurrentPrice()}`;
        // Only set price offset if metafield discount applies (no compare_at_price discount)
/*         if (discountValue != 0 && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
          price.setAttribute("data-price-offset", `-${discountValue / 100}`);
        } */
        price.setAttribute("data-variant-id", this.currentVariant.id);
      });

      this.stickyPriceRegular.forEach((price) => {
        price.innerHTML = `$${this.getCurrentPrice()}`;
        // Only set price offset if metafield discount applies (no compare_at_price discount)
/*         if (discountValue != 0 && !(this.currentVariant.compare_at_price > this.currentVariant.price)) {
          price.setAttribute("data-price-offset", `-${discountValue / 100}`);
        } */
        price.setAttribute("data-variant-id", this.currentVariant.id);
      });


      if (this.comparePrice) {
        this.comparePrice.forEach((comparePrice) => {
          comparePrice.setAttribute("data-variant-id", this.currentVariant.id);
          comparePrice.innerHTML = `$${this.currentVariant.compare_at_price / 100}`;
          if(this.currentVariant.compare_at_price == null){
            comparePrice.closest(".price-v1").classList.remove("price--on-sale");
            document.querySelectorAll(".sticky-atc__wrapper .price-v1").forEach(price => {
              price.classList.remove("price--on-sale");
            });
          } else {
            comparePrice.closest(".price-v1").classList.add("price--on-sale");
            document.querySelectorAll(".sticky-atc__wrapper .price-v1").forEach(price => {
              price.classList.add("price--on-sale");
            });
          }
        });
      }

      if (discountValue === 0) {
        this.comparePrice.forEach((comparePrice) => {
          comparePrice.innerHTML = `$${new Intl.NumberFormat().format(this.currentVariant.compare_at_price / 100)}`;
        });
      }

      if (discountValue === 0 && ((this.currentVariant.compare_at_price === this.currentVariant.price) || this.currentVariant.compare_at_price === null)) {
        this.comparePrice.forEach((comparePrice) => {
          comparePrice.innerHTML = "";
        });
      } else {
        this.comparePrice.forEach((comparePrice) => {
          comparePrice.classList.remove("hidden");
          comparePrice.parentElement.classList.remove("hidden");
        });
      }

      if (discountValue === 0 && this.currentVariant.compare_at_price <= this.currentVariant.price) {
        this.stickyComparePrice.forEach((comparePrice) => {
          comparePrice.classList.add("hidden");
        });
      } else {
        this.stickyComparePrice.forEach((comparePrice) => {
          comparePrice.classList.remove("hidden");
          comparePrice.parentElement.classList.remove("hidden");
        });
      }
    }
    /**
     * Get price & replace it with updated price
     */
    /*     const price = $(".price .price__regular dd .price-item");
    
        price.html(`$${this.getCurrentPrice()}`); */
  }

  updateCustomizeProductToMatch(optionGroup, value) {
    /**
     * Get main product
     */
    this.productsToUpdateOnOptionChange.forEach((item) => {
      if (optionGroup.toLowerCase() === item.optionKey.toLowerCase()) {
        $(
          `[data-product-id="${item.productId}"] fieldset .product-form__variant-list label`
        ).hide();
        $(
          `[data-product-id="${item.productId}"] fieldset [data-name="${value}"]`
        )
          .show()
          .click();
      }
    });
  }

  lockScreen() {
    this.scrollY = window.scrollY;
    document.body.style.top = `-${this.scrollY}px`;
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.position = "fixed";
  }

  unlockScreen() {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(this.scrollY || "0"));
  }

  toggleModal() {
    if (this.specModalOpen) {
      this.unlockScreen();
      $("[data-modal-specifications]").fadeOut(200);
      this.specModalOpen = false;
    } else {
      $("[data-modal-specifications]").fadeIn(200);
      this.specModalOpen = true;
      setTimeout(() => {
        this.lockScreen();
      }, 200);
    }
  }

  /**
   *
   * Update URL on variant change
   */
  updateURL() {
    if (!this.currentVariant) return;
    
    // Get current URL search parameters
    const urlParams = new URLSearchParams(window.location.search);
    
    // Update or add the variant parameter
    urlParams.set('variant', this.currentVariant.id);
    let pdpCallout = document.querySelectorAll(`.variant-${this.currentVariant.id}`)
    if (pdpCallout.length > 0) {
      pdpCallout.forEach(function (e, i) {
        e.classList.add('active')
      })
    } else {
      let pdpCalloutmain = document.querySelectorAll('.free_pdp_visibility')
      if (pdpCalloutmain.length > 0) {
        pdpCalloutmain.forEach(function (e, i) {
          e.classList.remove('active')
        })
      }
    }
    // Construct the new URL with preserved parameters
    const newUrl = `${this.dataset.productUrl}?${urlParams.toString()}`;
    
    window.history.replaceState(
      {},
      "",
      newUrl
    );
  }

  /**
   *
   * Cart
   * Custom Cart
   */
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer__content",
        section: document.getElementById("cart-drawer__content").dataset.id,
        selector: ".cart-drawer__content",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }

  /**
   * Add To Cart
   */
  addToCart() {
    const items = [];
    const mainProd = {
      id: this.currentVariant.id,
      quantity: 1,
    };
    items.push(mainProd);

    if (this.selectedAdditionalProducts.length > 0) {
      this.selectedAdditionalProducts.forEach((product) => {
        items.push({
          id: product.id,
          quantity: product.quantity,
        });
      });
    }

    if (this.freeProduct) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('fathersday')) {
        items.push({
          id: this.freeProductId,
          quantity: 1,
        });
      }
    }

    const body = JSON.stringify({
      items,
      sections: this.getSectionsToRender().map((section) => section.section),
    });

    document
      .querySelector(".discount-announcements-heading")
      ?.classList.add("hidden");
    document
      .querySelector(".discount-announcements-heading-discount-applied")
      ?.classList.add("hidden");
    document
      .querySelector(".discount-announcements-heading-updating-discounts")
      ?.classList.remove("hidden");

    fetch(`/cart/add.js`, {
      body,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((parsedState) => {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

            elementToReplace.innerHTML = getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );

          if (typeof window.flyOutLoad === "function") {
            window.flyOutLoad(); // Safely call the function
          }
        });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector("cart-drawer").open();
        if (typeof window.variantOptionChangeDrawer === "function") {
          window.variantOptionChangeDrawer();
        }
        if (typeof window.updateDiscountAnnouncements === "function") {
          window.updateDiscountAnnouncements();
        }
      });
  }
}


$(document).ready(function () {
  customElements.define("section-main-product-group", productGroup);
});

function updateSwatches() {
  const differentSwatches = document.querySelectorAll('.variant-type-group.different-level');
  differentSwatches.forEach(wrapper => {
    let inputSwatche = wrapper.querySelector('input[type="radio"]:checked') || wrapper.querySelector('input[type="checkbox"]:checked');
    const swatchElement = wrapper.querySelector(".different-swatches");
    if (inputSwatche) {
      swatchElement.innerHTML = inputSwatche.value;
    } else {
      swatchElement.innerHTML = "";
    }
  });
}
updateSwatches();

const toggleButton = document.querySelectorAll('.features--wrapper .features-button');
toggleButton.forEach(button => {
  button.onclick = function (event){
    this.closest(".features--wrapper").classList.toggle("active");
    this.closest(".features--wrapper").querySelector(".features-accordion").classList.toggle("active");
  }
})
document.querySelectorAll('.sticky-atc__wrapper .stickyButtonAddToCart').forEach(button => {
  button.addEventListener('click', function(e) {
    const stickyPopup = this.closest('.sticky-bar-popup');
    if (stickyPopup && stickyPopup.classList.contains('active')) {
      const finalAddToCartButton = document.querySelector('.final-add-to-cart.buttonAddToCart');
      if (finalAddToCartButton) {
        finalAddToCartButton.click();
      }
    } else {
      if (stickyPopup) {
        stickyPopup.classList.add('active');
      }
      document.querySelector("body").classList.add("overlay");
    }
  });
});
document.querySelectorAll('.sticky-atc__wrapper .close-sticky-popup').forEach(button => {
  button.addEventListener('click', function(e) {
    const stickyPopup = this.closest('.sticky-bar-popup');
    if (stickyPopup) {
      stickyPopup.classList.remove('active');
      document.querySelector("body").classList.remove("overlay");
    }
  });
});
document.addEventListener('click', function(event) {
  const popup = document.querySelector('.sticky-bar-popup');
  if (popup && popup.classList.contains('active')) {
    if (!popup.contains(event.target)) {
      popup.classList.remove('active');
      document.querySelector("body").classList.remove("overlay");
    }
  }
});

document.querySelectorAll('.sticky-atc__wrapper .sticky-add-to-cart').forEach(button => {
  button.addEventListener('click', function(e) {
  const stickyBtn = this.closest('.sticky-atc__content.hide-mobile');
    if (stickyBtn) {
      const finalAddToCartButton = document.querySelector('.final-add-to-cart.buttonAddToCart');
      if (finalAddToCartButton) {
        finalAddToCartButton.click();
      }
    }
  });
});

// Function to update customize product price display
function updateCustomizeProductPrice(labelElement) {
  if (!labelElement) return;
  
  const varId = labelElement.getAttribute('data-varid');
  const price = labelElement.getAttribute('data-price');
  const customizeProduct = labelElement.closest('.customize-product');
  
  if (!customizeProduct || !price) return;
  
  // Update the data attributes
  customizeProduct.setAttribute('data-selected-variant', varId);
  customizeProduct.setAttribute('data-price', price);
  
  // Update the visual price display
  const priceElement = customizeProduct.querySelector('.customize-product__price');
  const compareAtPriceElement = customizeProduct.querySelector('.customize-product__compare-at-price');
  
  if (priceElement) {
    // Get product info for discount calculations
    const productId = customizeProduct.getAttribute('data-product-id');
    const compareAtPrice = labelElement.getAttribute('data-compare-at-price') || 0;
    
    // Find the product data to check for discounts
    const productData = getProductDataForCustomizeProduct(productId, price);
    
    // Update the main price
    priceElement.textContent = productData.finalPrice;
    
    // Update compare-at-price if present
    if (compareAtPriceElement && compareAtPrice && parseInt(compareAtPrice) > 0) {
      const discount = parseFloat(customizeProduct.getAttribute('data-discount')) || 0;
      const bundleAddonSave = parseFloat(customizeProduct.getAttribute('data-bundle-addon-save')) || 0;
      const addonDiscountEnabled = customizeProduct.getAttribute('data-addon-discount-enabled') === 'true';
      
      if ((discount > 0) || (bundleAddonSave > 0 && addonDiscountEnabled)) {
        const compareAtPriceInDollars = parseInt(compareAtPrice) / 100;
        const formattedCompareAtPrice = '$' + compareAtPriceInDollars.toFixed(2).replace('.00', '');
        compareAtPriceElement.textContent = formattedCompareAtPrice;
        compareAtPriceElement.style.display = 'block';
      } else {
        compareAtPriceElement.style.display = 'none';
      }
    } else if (compareAtPriceElement) {
      compareAtPriceElement.style.display = 'none';
    }
  }
}

// Helper function to get product data and calculate discounts
function getProductDataForCustomizeProduct(productId, variantPrice) {
  const customizeProduct = document.querySelector(`[data-product-id="${productId}"]`);
  
  if (!customizeProduct) {
    const priceInDollars = parseInt(variantPrice) / 100;
    return {
      hasDiscount: false,
      finalPrice: '$' + priceInDollars.toFixed(2).replace('.00', '')
    };
  }
  
  const discount = parseFloat(customizeProduct.getAttribute('data-discount')) || 0;
  const bundleAddonSave = parseFloat(customizeProduct.getAttribute('data-bundle-addon-save')) || 0;
  const addonDiscountEnabled = customizeProduct.getAttribute('data-addon-discount-enabled') === 'true';
  
  let finalPrice = parseInt(variantPrice);
  let hasDiscount = false;
  
  // Apply discounts if available
  if (discount > 0) {
    const discountAmount = discount * 100;
    finalPrice = finalPrice - discountAmount;
    hasDiscount = true;
  } else if (bundleAddonSave > 0 && addonDiscountEnabled) {
    const discountAmount = bundleAddonSave * 100;
    finalPrice = finalPrice - discountAmount;
    hasDiscount = true;
  }
  
  // Convert from cents to dollars and format
  const priceInDollars = finalPrice / 100;
  const formattedPrice = '$' + priceInDollars.toFixed(2).replace('.00', '');
  
  return {
    hasDiscount: hasDiscount,
    finalPrice: formattedPrice
  };
}




